import {useEffect, useState} from "react";
import ReportUtils from "../../../../../../utils/report-utils.js";

export default function CorporationNotifications({ data }) {
    const notificationByCorpotationData = data?.allClones ?? [];
    const [limit, setLimit] = useState(15);

    const passedLimit = notificationByCorpotationData.length > 15;

    const seeMoreOsLess = () => {
        setLimit((prevState) => (prevState ? null : 15));
    }

    useEffect(() => {
        ReportUtils.createExportableTable(
            null,
            null,
            "Notificações por corporação",
            "notifications-by-corporation-table-export",
        );
    }, [notificationByCorpotationData]);

    return (
        <>
            <span className="chart-title">Notificações por corporação {passedLimit && limit ? "(TOP 15)" : ""}</span>
            <table
                id="notifications-by-corporation-table"
                className="table report-table mt-3"
            >
                <thead className="thead-background">
                    <tr className="bg-[#f6f6f6] text-left">
                        <th className="w-[33%]">Município 1</th>
                        <th className="w-[33%]">Município 2</th>
                        <th className="w-[33%]">Qtd.</th>
                    </tr>
                </thead>
                <tbody>
                {(limit
                    ? notificationByCorpotationData.slice(0, limit)
                    : notificationByCorpotationData
                ).map((element, index) => (
                    <tr key={index} className="table-break-word">
                        <td>{element.cityname1 ?? ""}</td>
                        <td>{element.cityname2 ?? ""}</td>
                        <td>{element.value ?? 0}</td>
                    </tr>
                ))}
                </tbody>
            </table>

            {passedLimit && (
                <div className="text-end mt-1">
                    <span
                        className="see-more print-hide cursor-pointer"
                        onClick={seeMoreOsLess}
                    >
                        {limit ? "Ver mais" : "Ver menos"}
                    </span>
                </div>
            )}

            <table
                id="notifications-by-corporation-table-export"
                className="hidden"
                sheet-name="Notificações por corporação"
            >
                <thead>
                    <tr>
                        <th>Município 1</th>
                        <th>Município 2</th>
                        <th>Qtd.</th>
                    </tr>
                </thead>
                <tbody>
                {notificationByCorpotationData.map((element, index) => (
                    <tr key={index}>
                        <td>{element.cityname1 ?? ""}</td>
                        <td>{element.cityname2 ?? ""}</td>
                        <td>{element.value ?? 0}</td>
                    </tr>
                ))}
                </tbody>
            </table>

            <div id="chart-tables" />
            <div className="chart-divisor" />
        </>
    )
}